var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex justify-between items-center"},[_c('div',{staticClass:"w-[45%] border border-px border-[#CCCCCC]"}),_c('span',[_vm._v("O")]),_c('div',{staticClass:"w-[45%] border border-px border-[#CCCCCC]"})])
}]

export { render, staticRenderFns }